import { render } from "./CustomerInfoPanel.vue?vue&type=template&id=f8017dc4&scoped=true"
import script from "./CustomerInfoPanel.vue?vue&type=script&lang=js"
export * from "./CustomerInfoPanel.vue?vue&type=script&lang=js"

import "./CustomerInfoPanel.vue?vue&type=style&index=0&id=f8017dc4&lang=scss&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8017dc4"]])

export default __exports__